exports.INITIAL = 'initial';
exports.SUCCESS = 'success';
exports.ERROR = 'error';
exports.PENDING = 'pending';
